import { renderSlot as _renderSlot, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = ["data-qa"]
const _hoisted_2 = {
  key: 0,
  class: "gfu-heading gfu-heading--text gfu-box-header__title"
}
const _hoisted_3 = {
  key: 1,
  class: "gfu-box-header__subtitle"
}
const _hoisted_4 = {
  key: 2,
  class: "gfu-box-header__actions"
}
const _hoisted_5 = {
  key: 1,
  class: "gfu-box__footer gfu-form__footer",
  "data-qa": "box-footer"
}
const _hoisted_6 = {
  key: 2,
  class: "gfu-box__balloon"
}

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass($options.classes)
  }, [
    ($options.showHeader)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "gfu-box-header",
          "data-qa": `box-title:${$props.title}`
        }, [
          ($props.title || _ctx.$slots['title'])
            ? (_openBlock(), _createElementBlock("h2", _hoisted_2, [
                _renderSlot(_ctx.$slots, "title", {}, () => [
                  _createTextVNode(_toDisplayString($props.title), 1 /* TEXT */)
                ])
              ]))
            : _createCommentVNode("v-if", true),
          (_ctx.$slots['subtitle'])
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _renderSlot(_ctx.$slots, "subtitle")
              ]))
            : _createCommentVNode("v-if", true),
          (_ctx.$slots['actions'])
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                _renderSlot(_ctx.$slots, "actions")
              ]))
            : _createCommentVNode("v-if", true)
        ], 8 /* PROPS */, _hoisted_1))
      : _createCommentVNode("v-if", true),
    _renderSlot(_ctx.$slots, "default"),
    _renderSlot(_ctx.$slots, "content"),
    (_ctx.$slots['footer'])
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _renderSlot(_ctx.$slots, "footer")
        ]))
      : _createCommentVNode("v-if", true),
    (_ctx.$slots['balloon'])
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
          _renderSlot(_ctx.$slots, "balloon")
        ]))
      : _createCommentVNode("v-if", true)
  ], 2 /* CLASS */))
}